function Collapsible(props) {
  const [display, setDisplay] = React.useState("none");
  const width = props.width;
  const maxWidth = props.maxWidth;
  function switchDisplay() {
    display == "block" ? setDisplay("none") : setDisplay("block");
  }
  React.useEffect(() => {
    if (maxWidth && maxWidth > 0) {
      width > maxWidth ? setDisplay("block") : setDisplay("none");
    }
  }, [props]);
  if (maxWidth && maxWidth > 0) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      onClick: width < maxWidth ? () => switchDisplay() : null,
      className: "collapsible-title"
    }, props.title, /*#__PURE__*/React.createElement("img", {
      alt: "Arrow down",
      width: "24px",
      height: "15px",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/Vector.png?v=1678377834",
      className: "arrow",
      style: {
        display: width < maxWidth ? "block" : "none"
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: display
      }
    }, /*#__PURE__*/React.createElement("ul", {
      className: "unmarked-list"
    }, props.children)));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "oneFilterMobile"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: () => switchDisplay(),
      className: "collapsible-title collapsible-title-filters"
    }, props.title, /*#__PURE__*/React.createElement("img", {
      alt: "Arrow down",
      className: "filtersArrowMobile",
      width: "30px",
      height: "15px",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/arrowDownNew.svg?v=1683641051"
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: display
      }
    }, /*#__PURE__*/React.createElement("ul", {
      className: "unmarked-list"
    }, props.children)));
  }
}
